module.exports = new __parcel__URL__("focus.d37eda71.png").toString();